export default {
      id: "oc-menu-helm-usage",
      viewBox: "0 0 1024 1024",
      url: __webpack_public_path__ + "sprite.svg#oc-menu-helm",
      toString: function () {
        return this.url;
      }
    }